var map = {
	"./contact/createMainInitialValue": 1014,
	"./cpo/createMainInitialValue": 1015,
	"./customer/createMainInitialValue": 1016,
	"./forwarderPo/createMainInitialValue": 1017,
	"./incomingInvoice/createMainInitialValue": 1018,
	"./incomingPayment/createMainInitialValue": 1019,
	"./outgoingInvoice/createMainInitialValue": 1020,
	"./outgoingPayment/createMainInitialValue": 1021,
	"./outgoingQuote/createMainInitialValue": 1022,
	"./product/createMainInitialValue": 1023,
	"./receiving/createMainInitialValue": 1024,
	"./shipping/createMainInitialValue": 1025,
	"./spo/createMainInitialValue": 1026,
	"./spoSched/createMainInitialValue": 1027,
	"./vatDeductRecord/createMainInitialValue": 1028,
	"./vendor/createMainInitialValue": 1029
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1013;